import { Icon } from '@eventbrite/legacy-eds.icon';
import { AlertChunky as AlertChunkySvg } from '@eventbrite/legacy-eds.iconography';
import { ErrorBoundary } from '@eventbrite/legacy-infra.error-boundary';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './ErrorBoundary.module.scss';

const ViewFallBack = () => {
    return (
        <div
            className={styles.errorContainer}
            style={{ flexDirection: 'column' }}
        >
            <Icon size="medium" type={<AlertChunkySvg />} />
            <div className={styles.errorTitle}>
                {gettext('Uh oh.')}
            </div>
            <div className={styles.errorMessage}>
                {gettext('Looks like we have a problem.')}
            </div>
            <div className={styles.errorFooter}>
                {gettext(
                    'Our team has been notified and we are investigating.',
                )}
            </div>
        </div>
    );
};

export const ViewErrorBoundary = (props: { children: React.ReactNode }) => {
    return (
        <ErrorBoundary fallback={()=><ViewFallBack />}>
            {props.children}
        </ErrorBoundary>
    );
};

export const ModalErrorBoundary = (props: { children: React.ReactNode }) => {
    return <ErrorBoundary fallback={()=><div />}>{props.children}</ErrorBoundary>;
};
